import React from "react";
import { motion } from "framer-motion";

const testimonials = [
    {
        name: "Rahul Mehra",
        position: "Director",
        feedback: "V9 Prime Force has been instrumental in scaling our team with highly skilled professionals. Their commitment is truly commendable!",
    },
    {
        name: "Priya Sharma",
        position: "HR Head",
        feedback: "Their team understood our specific requirements and delivered quality candidates on time. Exceptional service!",
    },
    {
        name: "Amit Verma",
        position: "Project Manager",
        feedback: "Thanks to V9 Prime Force, we could meet our project deadlines by hiring reliable and experienced workforce promptly.",
    },
];

const Testimonial = () => {
    return (
        <div className="testimonial-section">
            <h2 className="testimonial-heading">What Our Clients Say</h2>
            <div className="testimonial-cards">
                {testimonials.map((testimonial, index) => (
                    <motion.div
                        key={index}
                        className="testimonial-card"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                    >
                        <p className="testimonial-feedback">"{testimonial.feedback}"</p>
                        <div className="testimonial-author">
                            <h4 className="testimonial-name">{testimonial.name}</h4>
                            <p className="testimonial-position">{testimonial.position}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Testimonial;
